export default __webpack_public_path__ + "static/media/beach.138e78cf.svg";